/**
 * Tabellen als Karten auf dem Handy (01.11.2026).
 *
 * Listentabellen mit der Klasse `ew-karten` werden unter 640 px Breite als Karten dargestellt
 * (CSS in index.css): jede Zeile eine Karte, die erste Spalte als Titel, darunter
 * „Spaltenüberschrift: Wert“. Damit das CSS die Überschrift kennt, schreibt diese Funktion
 * den Text der <th> automatisch als `data-label` an jede Zelle – auch für Zeilen, die React
 * später nachlädt (MutationObserver). colSpan wird berücksichtigt.
 *
 * Opt-in: nur Tabellen mit `ew-karten`. Layout-, Editor- und Matrix-Tabellen bleiben unberührt.
 */

const beschriftungen = (table) => {
  const kopf = table.tHead?.rows?.[table.tHead.rows.length - 1];
  if (!kopf) return [];
  const liste = [];
  for (const th of kopf.cells) {
    const text = (th.getAttribute('data-label') ?? th.textContent ?? '').replace(/\s+/g, ' ').trim();
    for (let i = 0; i < (th.colSpan || 1); i++) liste.push(text);
  }
  return liste;
};

const beschriften = (table) => {
  const labels = beschriftungen(table);
  if (!labels.length) return;
  for (const body of table.tBodies) {
    for (const tr of body.rows) {
      let spalte = 0;
      for (const td of tr.cells) {
        const text = td.colSpan > 1 ? '' : (labels[spalte] || '');
        if (td.getAttribute('data-label') !== text) td.setAttribute('data-label', text);
        spalte += td.colSpan || 1;
      }
    }
  }
};

export function installTabellenKarten() {
  if (typeof window === 'undefined' || window.__ewTabellenKarten) return;
  window.__ewTabellenKarten = true;

  let geplant = false;
  const alle = () => {
    geplant = false;
    document.querySelectorAll('table.ew-karten').forEach(beschriften);
  };
  const planen = () => {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(alle);
  };

  const start = () => {
    alle();
    new MutationObserver(planen).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
}
